import React, { useState } from 'react';
import { Select, Option, Divider } from '@mui/joy';
import { Typography, IconButton, Button } from '@mui/joy';
import { Modal, ModalDialog, ModalClose, DialogTitle, DialogContent } from '@mui/joy';
import { Card, Chip, Stack } from '@mui/joy';

import PillsList from '../PillsListComponent';
import KWPopUpComponent from './KeywordPopUpComponent';

import AddIcon from '@mui/icons-material/Add';

const networking = require('../../Networking/API');

const STATE_COLORS: Record<string, any> = {
    'new': 'primary',
    'follow': 'warning',
    'assigned': 'info',
    'closed': 'success',
};

function ReviewsDistributionByIssue({ reviews, issues, handler }: any) {
    const [openAddKeyword, setOpenAddKeyword] = useState(false);
    const [currentIssue, setCurrentIssue] = useState(false);

    var distributed: any[] = [];
    var graphData: any[] = []

    const states = ['New',
        'Assigned',
        'Follow',
        'Closed'
    ]

    function removeIssue(issue: any) {
        networking.removeIssue(issue.id).then((stage: any) => {
            handler(true);
        }).catch((error: Error) => {
        });
    }

    function addKeyword(issue: any) {
        setCurrentIssue(issue);
        setOpenAddKeyword(true)
    }

    function deleteKeyword(keyword: any, issue: any) {
        const newKw = issue.keywords.filter((kw: string) => { return kw !== keyword });

        networking.removeKeyword(issue, newKw).then((stage: any) => {
            handler(true);
        }).catch((error: Error) => {
        });
    }

    function updateToState(event: any, value: any, issue: any) {
        if (!value) return;

        networking.updateIssueState(issue, issue.keywords.join(), value).then((issue: any) => {
            console.log('UPDATED STATE');

            handler(true);
        }).catch((error: Error) => {
            console.log(error.stack);
        });
    }

    function keywordSaved() {
        handler(true);
    }

    issues.map((issue: any, index: any) =>
        distributed.push({
            "id": issue.id,
            "issue": issue.title,
            "state": issue.state,
            "keywords": issue.keywords,
            "index": index,
            "reviews": reviews.filter((review: Review) => issue.keywords.some((v: any) => review.content.toLocaleLowerCase().includes(v.toLocaleLowerCase())))
        })
    );

    // Sort issues by name
    distributed.sort((a: any, b: any) => a.issue.localeCompare(b.issue));

    issues.map((issue: any) =>
        graphData.push(reviews.filter((review: Review) => issue.keywords.some((v: any) => review.content.toLocaleLowerCase().includes(v.toLocaleLowerCase()))).length)
    );

    const distribution = distributed.map((issue: any) =>
        <Card
            key={issue.id}
            variant="outlined"
            sx={{
                backgroundColor: '#ffffff',
                mb: 1.5,
            }}>
            <Stack spacing={1}>
                {/* Header Row */}
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={1}>
                    <Typography
                        level="title-sm"
                        sx={{ fontWeight: 600, minWidth: 0, flex: 1 }}>
                        {issue.issue}
                    </Typography>
                    <Stack direction="row" spacing={0.75} alignItems="center">
                        <Select
                            color="neutral"
                            value={issue.state}
                            size="sm"
                            variant="plain"
                            onChange={(event, newValue) => updateToState(event, newValue, issue)}
                            renderValue={(selected) =>
                                selected && (
                                    <Chip
                                        size='sm'
                                        color={STATE_COLORS[selected.value.toLowerCase()] || 'neutral'}
                                        variant="soft">
                                        {selected.label}
                                    </Chip>
                                )
                            }>
                            {states && states.map((option) => (
                                <Option key={option} value={option}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Chip
                                            size='sm'
                                            color={STATE_COLORS[option.toLowerCase()] || 'neutral'}
                                            variant="soft">
                                            {option}
                                        </Chip>
                                    </Stack>
                                </Option>
                            ))}
                        </Select>
                        <Button
                            size='sm'
                            onClick={() => removeIssue(issue)}
                            color='danger'
                            variant="soft"
                            sx={{ minWidth: 'auto' }}>
                            Remove
                        </Button>
                    </Stack>
                </Stack>

                {/* Keywords and Status Row */}
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ flexWrap: 'wrap' }}>
                    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ flex: 1, minWidth: 200 }}>
                        <PillsList
                            issue={issue}
                            keywords={issue.keywords}
                            color='light'
                            show={true}
                            handler={deleteKeyword} />
                        <IconButton
                            size='sm'
                            onClick={() => addKeyword(issue)}
                            variant="outlined"
                            color="primary"
                            sx={{
                                p: 0.5,
                                '&:hover': {
                                    bgcolor: 'primary.100',
                                }
                            }}>
                            <AddIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Stack>
                </Stack>
            </Stack>
        </Card>
    );

    return (
        <>
            {/* New Topic modal */}
            <Modal
                open={openAddKeyword}
                onClose={() => setOpenAddKeyword(false)}>
                <ModalDialog
                    color="neutral"
                    layout="center"
                    size="sm"
                    variant="plain"
                    minWidth={800}>
                    <ModalClose />
                    <DialogTitle>
                        Add new keywords
                    </DialogTitle>
                    <DialogContent>
                        Add new keywords to spotlight key insights from reviews.
                    </DialogContent>
                    <Divider inset="none" />
                    <div className='pt-2'>
                        <KWPopUpComponent
                            issue={currentIssue}
                            title='Add new keywords'
                            message=''
                            handler={keywordSaved} />
                    </div>
                </ModalDialog>
            </Modal>

            <div style={{ marginTop: '1rem' }}>
                {distribution}
            </div>
        </>
    )
}

export default ReviewsDistributionByIssue;